import { Box, Text, TextProps } from '@chakra-ui/react'
import React from 'react'

export interface HelperProps extends TextProps {
  error?: boolean
  inverted?: boolean
  success?: boolean
}

const HelperText: React.FC<HelperProps> = ({
  error,
  inverted,
  success,
  ...props
}) => {
  const primaryColor = error ? 'red.70' : success ? 'green.50' : undefined
  const bgColor = primaryColor && (inverted ? primaryColor : 'transparent')
  const color = primaryColor && (inverted ? 'white.0' : primaryColor)
  return (
    <Text
      as="span"
      bgColor={bgColor}
      color={color}
      fontSize="xs"
      px={inverted ? 1 : 0}
      {...props}
    />
  )
}

export const Helper: React.FC<HelperProps> = props => (
  <Box minW="100%" mt={1} width="min-content">
    <HelperText {...props} />
  </Box>
)

Helper.displayName = 'Helper'
